import { Cookies } from './';

const _cookies = new Cookies();

/**
 * Determines if the current user has previously logged into JG
 * @param {string} cookies - instance of the Cookies util class (for unit testing)
 */
export const hasPreviouslyLoggedIn = (cookies = _cookies) => {
	const userMetadata = cookies.JgUserMetadataCookie;
	return {
		hasLoggedIn: !!userMetadata.JGEmail,
		emailAddress: userMetadata.JGEmail || '',
		firstName: userMetadata.JGFirstName || '',
	};
};



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/utils/hasPreviouslyLoggedIn.js